import axios from 'axios';

import {envConfig} from 'config';
import {FilesAreaContent} from 'types';

const url = `${envConfig.fileServerApiUrl}/file-server/manage`;

type FilesOwner = {
    id: string;
    type: string;
}

const executeAction = async (body: any) => {
    const res = await axios.post(url, body);
    return res.data;
};

const getFolderContentFull = (owner: FilesOwner, area: string): Promise<FilesAreaContent> =>
    executeAction({owner, area, action: 'getFolderContentFull'});

const create = (owner: FilesOwner, area: string, fileName: string, base64: string) =>
    executeAction({owner, area, action: 'create', fileName, base64});

const remove = (owner: FilesOwner, area: string, fileName: string) =>
    executeAction({owner, area, action: 'remove', fileName});

export const filesManagerApi = {
    getFolderContentFull,
    create,
    remove
};